export default "<abw-page-builder-image-design [model]=\"model\" [value]=\"model.value\"></abw-page-builder-image-design>";